import { Checkbox, Image } from '@fluentui/react-components';
import useMonthlyPaymentContractStyles from './MonthlyPaymentContract.styles';
import {
    IBaseCheckboxProps,
    IContractCheckboxProps,
    IDeclineAssuranceCheckboxProps,
    IPaymentCheckboxProps
} from './MonthlyPaymentContract.types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';
import { RouteLink } from 'components/core';

const BaseCheckbox = (props: IBaseCheckboxProps) => {
    const { onChange, hide, children } = props;

    const styles = useMonthlyPaymentContractStyles();

    if (hide) return <></>;

    return (
        <Checkbox
            label={{ children: children }}
            className={styles.checkbox}
            onChange={(_, data) => onChange(data.checked as boolean)}
        />
    );
};

export const ContractCheckbox = (props: IContractCheckboxProps) => {
    const { lineNum, device, contractUrls, onChange } = props;
    const styles = useMonthlyPaymentContractStyles();

    const openPdf = () => {
        const currentContract = contractUrls.filter((c) => c.lineNumber == lineNum);
        window.open(currentContract[0]?.url, '_blank');
    };

    return (
        <>
            {device && !device.useRetailPrice ? (
                <>
                    <BaseCheckbox hide={!device || device.useRetailPrice} onChange={onChange}>
                        <span>I agree to monthly device installment plan contract</span>
                    </BaseCheckbox>
                    <div className={styles.pdfContainer}>
                        <Image
                            src='../wp-content/uploads/2024/11/installment-agreement-template.png'
                            className={styles.pdfThumbnail}
                            onClick={openPdf}
                        />
                        <FontAwesomeIcon
                            icon={faUpRightAndDownLeftFromCenter}
                            className={styles.pdfIconLink}
                            onClick={openPdf}
                        />
                    </div>
                </>
            ) : (
                <></>
            )}
        </>
    );
};

export const PaymentCheckbox = (props: IPaymentCheckboxProps) => {
    const { onChange } = props;
    return <BaseCheckbox onChange={onChange}>I agree to monthly payment of plan</BaseCheckbox>;
};

export const DeclineAssuranceCheckbox = (props: IDeclineAssuranceCheckboxProps) => {
    const { device, onChange } = props;

    return (
        <BaseCheckbox hide={!device || device.useAssurance} onChange={onChange}>
            <span>
                I agree to risks of declining{' '}
                <RouteLink text='assurance' target='_blank' url='/assurance' appearance='default' />
            </span>
        </BaseCheckbox>
    );
};
